(function(){
  function getConfig() {
    const configEl = document.getElementById('judgeme-config');
    if (configEl) {
      return {
        rating: configEl.dataset.rating || '4.7/5',
        totalReviews: configEl.dataset.totalReviews || '2394',
        reviewText: configEl.dataset.reviewText || 'reseñas de clientes'
      };
    }
    return {
      rating: '4.7/5',
      totalReviews: '2394',
      reviewText: 'reseñas de clientes'
    };
  }

  const config = getConfig();
  const NEW_HTML = `<strong>${config.rating}</strong> (<strong>${config.totalReviews}</strong> ${config.reviewText})`;

  let observer, lastContent = '', updateCount = 0;

  function updateBadge() {
    const badge = document.querySelector('.jdgm-prev-badge__text');

    if (!badge ||
        badge.innerHTML === NEW_HTML ||
        badge.innerHTML === lastContent ||
        updateCount > 5) return;

    lastContent = badge.innerHTML;
    updateCount++;

    observer.disconnect();
    badge.innerHTML = NEW_HTML;

    setTimeout(() => {
      if (observer && updateCount <= 5) {
        observer.observe(badge, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }, 50);
  }

  function initObserver() {
    const badge = document.querySelector('.jdgm-prev-badge__text');
    if (!badge) {
      setTimeout(initObserver, 100);
      return;
    }

    observer = new MutationObserver(updateBadge);
    observer.observe(badge, {
      childList: true,
      characterData: true,
      subtree: true
    });

    updateBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }

  window.addEventListener('beforeunload', () => {
    if (observer) observer.disconnect();
  });
})();
